import { memo } from 'react'
import { Box as MuiBox, ButtonBase, SxProps } from '@mui/material'
import { ChevronRightIcon, User01Icon } from '@/assets'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { useTranslations } from '@/core/translation'
import { useSidebarProfileController } from './SidebarProfile.controller'
import { sidebarProfileStyles as styles } from './SidebarProfile.style'
import { SidebarProfileProps } from './SidebarProfile.types'

function SidebarProfile(props: SidebarProfileProps) {
  const { isRail = false, isRound = false, showLabel = true } = props
  const t = useTranslations('sidebar')
  const { isAuthenticated, avatarUrl, email, displayName, initials, onOpen } =
    useSidebarProfileController(props)

  return (
    <ButtonBase
      sx={[styles.row, isRail && styles.rowRail, isRound && styles.rowRound] as SxProps}
      onClick={onOpen}
      aria-label={t('profile.open')}
      title={showLabel ? undefined : t('profile.open')}>
      <Box sx={[styles.avatarSlot, isRail && styles.avatarSlotRail] as SxProps}>
        {isAuthenticated ? (
          <Box component="span" sx={styles.avatar}>
            {avatarUrl ? (
              <MuiBox component="img" src={avatarUrl} alt="" sx={styles.avatarImage} />
            ) : (
              initials
            )}
          </Box>
        ) : (
          <Box component="span" sx={styles.avatarIcon}>
            <Box component={User01Icon} sx={styles.avatarIconGlyph} />
          </Box>
        )}
      </Box>

      {showLabel && (
        <>
          <Box sx={styles.details}>
            <Text component="span" sx={styles.name}>
              {isAuthenticated ? displayName || t('profile.account') : t('profile.signIn')}
            </Text>
            <Text component="span" sx={styles.email}>
              {isAuthenticated ? email || t('profile.addEmail') : t('profile.signInSub')}
            </Text>
          </Box>

          <Box component={ChevronRightIcon} sx={styles.chevronIcon} />
        </>
      )}
    </ButtonBase>
  )
}

export default memo(SidebarProfile)
